// update state
const setFolderViewAction = (payload) => {
    return {
        type: "FOLDERVIEWKEY",
        payload
    }

}

export default setFolderViewAction;




// WEBPACK FOOTER //
// ./src/actions/setFolderViewAction.js